import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/orders/utm`, {params})
    },
    summary(params) {
        return Vue.axios.get(`/orders/utm/summary`, {params})
    },
    options() {
        return Vue.axios.get(`/orders/utm/options`)
    }
}
